import { StoreReducerStateTypes } from './store.types';

export const allReducerStates = (state: StoreReducerStateTypes) => state;
